import { render, staticRenderFns } from "./BannerRecommendationBlock.vue?vue&type=template&id=f48f6962&"
import script from "./BannerRecommendationBlock.vue?vue&type=script&lang=js&"
export * from "./BannerRecommendationBlock.vue?vue&type=script&lang=js&"
import style0 from "./BannerRecommendationBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports